import React from "react";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../masters/master.css";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";

import * as Yup from "yup";

const prospectFilterForm = Yup.object().shape({
  assetType: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  brandCategory: Yup.string().required("Required"),
  assetName: Yup.string().required("Required"),
  floor: Yup.string().required("Required"),
  rangeFrom: Yup.string().required("Required"),
  rangeTo: Yup.string().required("Required"),
});

const prospectValidation = Yup.object().shape({
  brand_name: Yup.string().required("Required"),
  fitout_period: Yup.string().required("Required"),
  notice_period: Yup.string().required("Required"),
  lease_period: Yup.string().required("Required"),
  lockin_period: Yup.string().required("Required"),
  renewal_term: Yup.string().required("Required"),
  min_guarantee: Yup.string().required("Required"),
  revenue_share: Yup.string().required("Required"),
  rent_deposit: Yup.string().required("Required"),
  cam_deposit: Yup.string().required("Required"),
  cam_rate: Yup.string().required("Required"),
  marketing_fund: Yup.string().required("Required"),
  property_tax: Yup.string().required("Required"),
  parking: Yup.string().required("Required"),
  signage: Yup.string().required("Required"),
  stamp_duty_by: Yup.string().required("Required"),
  exclusivity: Yup.string().required("Required"),
  remarks: Yup.string().required("Required"),
});


const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class ProspectDetail extends React.Component {

  state = {
    redirect: false,
    brandCategories: [],
    brandCategoryName: "",
    brandCategory: "",
    assetTypeList: [],
    brandCategoryList: [],
    cityList: [],
    assetList: [],
    floorList: [],
    comparativeData: [],
    fiterFormData: [],
    initialValues: {
      assetType: "asdasd",
      city: "",
      brandCategory: "",
      assetName: "",
      floor: "",
      grossLeaseAreaFrom: "",
      grossLeaseAreaTo: "",
      rangeFrom: "",
      rangeTo: "",
    },
    prospectInitialValues: {
      brand_name: "",
      fitout_period: "",
      lease_period: "",
      lockin_period: "",
      min_guarantee: "",
      revenue_share: "",
      rent_deposit: "",
      cam_deposit: "",
      cam_rate: "",
      marketing_fund: "",
      property_tax: "",
      parking: "",
      signage: "",
      stamp_duty_by: "",
      exclusivity: "",
      remarks: "",
      notice_period: "",
      renewal_term: "",
    },
  };

  constructor(props) {
    super(props);
  }
  componentDidMount() {
    fetch(
      `${apiUrl.apiUrl.url}/prospect/fetch-prospect-details?id=${this.props.match.params.id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          fiterFormData: data.data,
          comparativeData: data.comparativeData,
        });
        
    })
    .catch((error) => {
    console.log(error);
    });

    
  }
  changeCity = (newValue) => {
    this.state.initialValues.city = newValue.value;
    this.state.initialValues.city = newValue.label;
    this.setState({});
    this.fetchAsset();
  };
  changeAssetType = (newValue) => {
    this.state.initialValues.assetType = newValue.value;
    this.state.initialValues.assetType = newValue.label;
    this.setState({});
  };
  changeBrandCategory = (newValue) => {
    this.state.initialValues.brandCategory = newValue.value;
    this.state.initialValues.brandCategory = newValue.label;
    this.setState({});
  };
  changeAsset = (newValue) => {
    this.state.initialValues.assetName = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    this.fetchFloor();
  };
  changeFloor = (newValue) => {
    this.state.initialValues.floor = newValue.value;
    this.state.initialValues.floor = newValue.label;
    this.setState({});
  };

  fetchAsset = () => {
    fetch(
      `${apiUrl.apiUrl.url}/prospect/fetch-asset?asset_type=${this.state.initialValues.assetType}&search_term=&city=${this.state.initialValues.city}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchFloor = () => {
    fetch(
      `${apiUrl.apiUrl.url}/prospect/fetch-floor?asset=${this.state.initialValues.assetName}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          floorList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div
        className="parentContainer"
        style={{
          float: "left",
          width: "100%",
          display: "block",
          overflowY: "auto",
          overflowX: "hidden",
          height: "100%",
        }}
      >
        <div
          style={{
            float: "left",
            width: "100%",
            display: "block",
          }}
        >
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <Formik initialValues={this.state.initialValues} enableReinitialize>
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Type <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <label>{this.state.fiterFormData.asset_type}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Brand <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <label>
                              {this.state.fiterFormData.brand_category}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            City <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <label>{this.state.fiterFormData.city}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div class="inputContainer col-lg-12 col-md-12">
                        <div class="row mb-3">
                          <label class="col-sm-4 col-form-label">
                            Gross Leasable Area Range (Sq.Ft)
                            <span class="astrik">*</span>
                          </label>
                          <div class="col-sm-3 dueDateFieldWidth">
                            <label>
                              From: {this.state.fiterFormData.gla_from}
                            </label>
                          </div>
                          <div class="col-sm-3 dueDateFieldWidth">
                            <label>To: {this.state.fiterFormData.gla_to}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Name <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <label>{this.state.fiterFormData.asset_name}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Floor <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <label>{this.state.fiterFormData.floor}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        <Formik
          initialValues={this.state.prospectInitialValues}
          enableReinitialize
          validationSchema={prospectValidation}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container-fluid">
                  <div className="row">
                    <div className="tableContainer prospectTable">
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">Field Name</th>
                            <th scope="col">Prospect</th>
                            {this.state.comparativeData.length >= 1 && (
                              <th scope="col">Comparative 001</th>
                            )}
                            {this.state.comparativeData.length >= 2 && (
                              <th scope="col">Comparative 002</th>
                            )}
                            {this.state.comparativeData.length >= 3 && (
                              <th scope="col">Comparative 003</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <h6>Brand Name</h6>
                            </td>
                            <td>
                              <label>
                                {this.state.fiterFormData.brand_name}
                              </label>
                            </td>
                            {this.state.comparativeData.length >= 1 && (
                              <td scope="col">
                                {this.state.comparativeData[0]["Brand Name"]}
                              </td>
                            )}
                            {this.state.comparativeData.length >= 2 && (
                              <td scope="col">
                                {this.state.comparativeData[1]["Brand Name"]}
                              </td>
                            )}
                            {this.state.comparativeData.length >= 3 && (
                              <td scope="col">
                                {this.state.comparativeData[2]["Brand Name"]}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>LEASE TERMS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Lease Term</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Fitout Period (Days)</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.fitout_period}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Lease Period</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.lease_period}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Lock In Period</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.lockin_period}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Notice Period</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.notice_period}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Renewal Terms</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.renewal_term}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>COMMERCIALS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Commercials</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Minimum Guarantee</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.min_guarantee}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Revenue Share (%)</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.revenue_share}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>SECURITY DEPOSITS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Security Deposits</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Rent Deposits (Months)</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.rent_deposit}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>CAM Deposits (Months)</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.cam_deposit}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>OTHER TERMS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Other Terms</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>CAM Rate</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.cam_rate}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Marketing Fund</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {
                                          this.state.fiterFormData
                                            .marketing_fund
                                        }
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Property Taxes</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.property_tax}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Parking</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.parking}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Signage</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.signage}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>OTHER CLAUSES</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Other Clauses</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Stamp Duty By</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.stamp_duty_by}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Exclusivity</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.exclusivity}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Remarks</h6>
                                    </td>
                                    <td>
                                      <label>
                                        {this.state.fiterFormData.remarks}
                                      </label>
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                            "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    );
  }
}

export default withRouter(ProspectDetail);
